export const REGIONDO_ROLLOUT_WAVES = [
  {
    week: 'KW7',
    branches: [
      { branchId: '66c45e35d32ecc24477351c7', locationName: 'Köln', longName: 'FunZone Köln' },
    ],
  },
  {
    week: 'KW8',
    branches: [
      { branchId: '64c8c84fa22a12483a42d816', locationName: 'Essen Kray', longName: 'FunZone Essen Kray' },
      { branchId: '64c8c816a22a12483a42d810', locationName: 'Düsseldorf', longName: 'FunZone Düsseldorf' },
    ],
  },
  {
    week: 'KW9',
    branches: [
      { branchId: '64c8c847a22a12483a42d814', locationName: 'Essen Borbeck', longName: 'FunZone Essen Borbeck' },
      { branchId: '64c8c823a22a12483a42d812', locationName: 'Duisburg', longName: 'FunZone Duisburg' },
    ],
  },
  {
    week: 'KW10',
    branches: [
      { branchId: '64c8c878a22a12483a42d81e', locationName: 'Mönchengladbach', longName: 'FunZone Mönchengladbach' },
      { branchId: '64c8c867a22a12483a42d81a', locationName: 'Kiel', longName: 'FunZone Kiel' },
    ],
  },
  {
    week: 'KW11',
    branches: [
      { branchId: '64c8c80da22a12483a42d80e', locationName: 'Bielefeld', longName: 'FunZone Bielefeld' },
    ],
  },
  {
    week: 'KW12',
    branches: [
      { branchId: '64c8c86da22a12483a42d81c', locationName: 'Mainz', longName: 'FunZone Mainz' },
      { branchId: '64c8c85fa22a12483a42d818', locationName: 'Frankfurt', longName: 'FunZone Frankfurt' },
    ],
  },
  {
    week: 'KW13',
    branches: [
      { branchId: '64c8c806a22a12483a42d80c', locationName: 'Augsburg', longName: 'FunZone Augsburg' },
      { branchId: '64c8c87fa22a12483a42d820', locationName: 'München', longName: 'FunZone München' },
    ],
  },
];

export function buildRolloutIndex() {
  const byBranchId = new Map();
  let i = 0;
  for (const wave of REGIONDO_ROLLOUT_WAVES) {
    for (const b of wave.branches) {
      if (!b?.branchId) continue;
      if (!byBranchId.has(b.branchId)) {
        byBranchId.set(b.branchId, i);
        i += 1;
      }
    }
  }
  return { byBranchId };
}

